import verge from 'verge'

import {
  VIEWPORT_TYPES,
  VIEWPORT_MAX_WIDTH_PHONE
} from '../../config/constants'

const {PHONE, DESKTOP} = VIEWPORT_TYPES

export default () => {
  const width = verge.viewportW()
  const height = verge.viewportH()
  const type = width > VIEWPORT_MAX_WIDTH_PHONE ? DESKTOP : PHONE

  return {width, height, type}
}


/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/viewport.js
 **/